import { FromAppConfig } from "@brandlive/client-auth/lib/types";

const BRAND_TV_DOMAIN = process.env.REACT_APP_BRAND_TV_DOMAIN as string;
const WEBINAR_PLUS_DOMAIN = process.env.REACT_APP_WEBINAR_PLUS_DOMAIN as string;

const BRANDTV_AUTH_CONFIG_STR = process.env.REACT_APP_BRAND_TV_AUTH_CONFIG as string;
const WEBINAR_PLUS_AUTH_CONFIG_STR = process.env.REACT_APP_WEBINAR_PLUS_AUTH_CONFIG as string;

export const BRANDTV_AUTH_CONFIG = (BRANDTV_AUTH_CONFIG_STR ? JSON.parse(BRANDTV_AUTH_CONFIG_STR) : {}) as FromAppConfig;
export const WEBINAR_PLUS_AUTH_CONFIG = (WEBINAR_PLUS_AUTH_CONFIG_STR ? JSON.parse(WEBINAR_PLUS_AUTH_CONFIG_STR) : {}) as FromAppConfig;

export const getFromAppConfigForCurrentLocation = () => {
	try {
		if (window.location.hostname.endsWith(BRAND_TV_DOMAIN)) {
			return BRANDTV_AUTH_CONFIG;
		}

		if (window.location.hostname.endsWith(WEBINAR_PLUS_DOMAIN)) {
			return WEBINAR_PLUS_AUTH_CONFIG;
		}
	} catch (error) {
		console.error('Error parsing from app config', error);
	}

	return { fromApp: 'Brandlive Platform' };
};

